import { Component, OnInit } from '@angular/core';
import { MainComponent } from '../main.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  public anno = new Date().getFullYear();
  public version = MainComponent.getInstance().webVersion;
  
  constructor() { }

  ngOnInit(): void {
  }

}
